var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { STATIC_CONFIG } from "./config";
import { getAuthHeader, sessionState } from "./session";
import { notifyNetworkError, notifySuccess } from "./utils";
export const uploadFile = (file, allowedTypes) => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append("file", file);
    const allowedTypesParam = allowedTypes ? `?type=${allowedTypes.join('|')}` : '';
    const uploadId = yield axios.post(`${STATIC_CONFIG.API_ROOT}/upload${allowedTypesParam}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(resp => resp.data, err => { throw err; });
    return { id: uploadId, filename: file.name };
});
/*
 * Convenience wrappers for axios HTTP calls
 */
export function getFullyQualifiedAPIUrl(path) {
    var _a;
    // If path starts with a '/', treat it as an absolute path. Otherwise, prepend network ID
    return path.startsWith("/") ? `${STATIC_CONFIG.API_ROOT}${path}` : `${STATIC_CONFIG.API_ROOT}/networks/${(_a = sessionState.session) === null || _a === void 0 ? void 0 : _a.networkId}/${path}`;
}
export function apiGet(path, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield axios.get(getFullyQualifiedAPIUrl(path), { headers: { "Content-Type": contentType || "application/json", "Authorization": getAuthHeader() } }).then(resp => { return resp.data; }, err => { throw err; });
    });
}
export function apiPut(path, body, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield axios.put(getFullyQualifiedAPIUrl(path), body, { headers: { "Content-Type": contentType || "application/json", "Authorization": getAuthHeader() } }).then(resp => { return resp.data; }, err => { throw err; });
    });
}
export function apiPutVoid(path, body, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        yield axios.put(getFullyQualifiedAPIUrl(path), body, { headers: { "Content-Type": contentType || "application/json", "Authorization": getAuthHeader() } }).then(resp => { }, err => { throw err; });
    });
}
export function apiPost(path, body, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield axios.post(getFullyQualifiedAPIUrl(path), body, { headers: { "Content-Type": contentType || "application/json", "Authorization": getAuthHeader() } }).then(resp => { return resp.data; }, err => { throw err; });
    });
}
export function apiPostVoid(path, body, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        yield axios.post(getFullyQualifiedAPIUrl(path), body, { headers: { "Content-Type": contentType || "application/json", "Authorization": getAuthHeader() } }).then(resp => { }, err => { throw err; });
    });
}
export function apiDelete(path, body, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield axios.delete(getFullyQualifiedAPIUrl(path), { headers: { "Content-Type": contentType || "application/json", "Authorization": getAuthHeader() } }).then(resp => { return resp.data; }, err => { throw err; });
    });
}
export function apiDeleteVoid(path, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        yield axios.delete(getFullyQualifiedAPIUrl(path), { headers: { "Content-Type": contentType || "application/json", "Authorization": getAuthHeader() } }).then(resp => { }, err => { throw err; });
    });
}
export const doApiAction = (tracker, actionName, successMessage, failureMessage, action) => {
    if (tracker) {
        tracker.value = actionName;
    }
    action()
        .then(() => {
        if (successMessage) {
            notifySuccess(successMessage);
        }
    })
        .catch(err => {
        if (failureMessage) {
            notifyNetworkError(failureMessage, err);
        }
    })
        .finally(() => { if (tracker) {
        tracker.value = null;
    } });
};
/*
 * Can be used by any entity-specific API which wants to expose comments-and-tasks functionality
 */
export const apiEntityTasksAndCommentsBase = (resourcePrefix) => {
    return {
        addComment: (entityId, message, attachments, notifyCaseworker) => apiPost(`${resourcePrefix}/${entityId}/comments`, { message: message, attachments: attachments, notifyCaseworker: notifyCaseworker }),
        getComments: (entityId) => apiGet(`${resourcePrefix}/${entityId}/comments`),
        getCommentAttachmentViewLink: (entityId, commentId, attachmentId) => apiGet(`${resourcePrefix}/${entityId}/comments/viewToken`)
            .then(viewToken => getFullyQualifiedAPIUrl(`${resourcePrefix}/${entityId}/comments/${commentId}/attachments/${attachmentId}?token=${encodeURIComponent(viewToken)}`)),
        addTask: (entityId, audience, message) => apiPost(`${resourcePrefix}/${entityId}/tasks`, { audience: audience, message: message }),
        getTasks: (entityId) => apiGet(`${resourcePrefix}/${entityId}/tasks`),
    };
};
